<template>
    <div>
        <div v-if="question.tip === 'radio' || question.tip === 'points_radio'" cols="12">
            <v-radio-group v-model="question.cevap" row hide-details class="mt-0 pt-0">
                <v-radio v-for="(option, optionindex) in options" v-bind:key="optionindex" v-bind:label="option" v-bind:value="option" v-bind:color="color" v-bind:disabled="!props.editable">
                    <template v-slot:label>
                        <span class="mb-n3" v-html="option"></span>
                    </template>
                </v-radio>
            </v-radio-group>
        </div>
        <div v-else-if="question.tip === 'checkbox'" cols="12">
            <v-row>
                <v-col v-for="(option, optionindex) in options" v-bind:key="optionindex" cols="auto">
                    <v-checkbox v-model="checkboxmodel" hide-details v-bind:label="option" v-bind:value="option" v-bind:color="color" class="mt-0 pt-0" v-bind:disabled="!props.editable">
                        <template v-slot:label>
                            <span class="mb-n3" v-html="option"></span>
                        </template>
                    </v-checkbox>
                </v-col>
            </v-row>
        </div>
        <div v-else-if="question.tip === 'file'" cols="12">
            <input type="file" v-show="false" ref="fileupload" v-on:change="FileUploadOnChange()" />
            <p v-if="filename.length > 0" class="mb-1">{{ $t("AL_UploadedFileName") }}: {{ filename }} </p>
            <div>
                <v-btn v-if="props.editable" text v-bind:color="color" class="mr-2" v-on:click="FileUploadOnClick()" >
                    <v-icon left>mdi-upload</v-icon>{{ $t("AL_UploadFile") }}
                </v-btn>
                <v-btn v-if="question.cevap.length > 0" text color="primary" class="mr-2" v-on:click="ShowFile()">
                    <v-icon left>mdi-eye</v-icon>{{ $t("AL_ViewFile") }}
                </v-btn>
                <v-btn v-if="question.cevap.length > 0 && props.editable" text color="error" class="" v-on:click="question.cevap = ''">
                    <v-icon left>mdi-delete</v-icon>{{ $t("AL_DeleteFile") }}
                </v-btn>
            </div>
        </div>
        <div v-else-if="question.tip === 'textarea'" cols="12">
            <v-textarea v-model="question.cevap" hide-details dense outlined v-bind:color="color" v-bind:disabled="!props.editable">
            </v-textarea>
        </div>
        <div v-else-if="question.tip === 'points_number'" cols="12">
            <v-text-field v-model="question.cevap" type="number" v-bind:placeholder="$t('KSurveyNumberInputDefaultPlaceholder')" hide-details dense outlined v-bind:color="color" v-bind:disabled="!props.editable">
            </v-text-field>
        </div>
        <div v-else cols="12">
            <v-text-field v-model="question.cevap" v-bind:type="question.tip" v-bind:placeholder="question.tip == 'number' ? $t('KSurveyNumberInputDefaultPlaceholder') : ''" hide-details dense outlined v-bind:color="color" v-bind:disabled="!props.editable">
            </v-text-field>
        </div>
        <div v-if="!ischild && Number(question.ekaciklamavar) === 1" cols="12" class="rounded border pa-2 mt-2">
            <span class="caption">{{ $t('OptionalAdditionalExplanation') }}</span>
            <v-textarea v-model="question.ekaciklama" rows="2" hide-details dense outlined v-bind:color="color" v-bind:disabled="!props.editable">
            </v-textarea>
        </div>
    </div>
</template>

<style>
    .v-input__append-outer {
        margin-top: 0 !important;
    }
</style>

<script>
    import Vue from 'vue';
    import Vuex from 'vuex';
    Vue.use(Vuex);

    import axios from "axios";
    import 'material-design-icons-iconfont/dist/material-design-icons.css';
    import { FormMixIn } from '@/MixIns/FormMixins';

    export default {
        name: 'KSurveyQuestion',
        mixins: [FormMixIn],
        components: {
        },
        props: {
            question: Object,
            props: Object,
            ischild: Boolean
        },
        data()
        {
            return {
                color: "blue",
                checkboxmodel: []
            };
        },
        computed: {
            options()
            {
                if (["radio", "checkbox", 'points_radio'].includes(this.question.tip))
                {
                    return this.question.secenekler.split(";");

                    //const secenekler = this.question.secenekler.split(";");
                    //const seceneklerwithpuan = this.question.seceneklerwithpuan.split(";");

                    //const options = [];
                    //for (let i = 0; i < secenekler.length; i++)
                    //{
                    //    const option = {};
                    //    option.secenek = secenekler[i];
                    //    if (seceneklerwithpuan.length > i)
                    //    {
                    //        option.secenekwithpuan = seceneklerwithpuan[i];
                    //    }
                    //    else
                    //    {
                    //        option.secenekwithpuan = secenekler[i];
                    //    }

                    //    options.push(option);
                    //}

                    //return options;
                }

                return [];
            },
            filename()
            {
                if (["file"].includes(this.question.tip))
                {
                    return this.question.cevap.split("__").at(-1);
                }

                return "";
            }
        },
        watch: {
            checkboxmodel(newVal, oldVal)
            {
                this.question.cevap = newVal.filter(i => i).join(";");
            },
            "question.cevap": function(newVal, oldVal)
            {
                if (newVal.length > 0)
                {
                    this.question.error = false;
                }
            }
        },
        methods: {
            ShowFile()
            {
                window.open(`/api/showfile?file=${encodeURIComponent(this.question.cevap)}`);
            },
            FileUploadOnClick()
            {
                this.$refs.fileupload.click();
            },
            FileUploadOnChange()
            {
                const self = this;

                self.props.processing = true;

                let formData = new FormData();
                formData.append("file", self.$refs.fileupload.files[0]);
                axios.post(
                        "/api/upload",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }
                    )
                    .then(function (response)
                    {
                        if (response.status !== 200)
                        {
                            throw new Error(response.statusText);
                            return;
                        }

                        if (response.data.errorCode !== 0)
                        {
                            throw new Error(response.data.errorMessage);
                            return;
                        }

                        if (response.data.error && response.data.error.length > 0)
                        {
                            throw new Error(response.data.error);
                            return;
                        }

                        self.question.cevap = response.data.url;
                        self.props.processing = false;
                        self.$refs.fileupload.value = "";
                    })
                    .catch(function (error)
                    {
                        self.props.processing = false;
                        self.$refs.fileupload.value = "";
                        self.$root.$emit('setUpMessage', {
                            messageBody: self.$t(error.message),
                            infoBody: self.$t('Warning'),
                            messageType: 'E'
                        });
                    });
            }
        },
        mounted()
        {
            this.checkboxmodel = this.question.cevap.split(";");
        }
    };
</script>
